export default __webpack_public_path__ + "locales/es/Payments.json?hash=d1b42efe21fa16a77ec68933d1e38a8f";